import { render, staticRenderFns } from "./RegistrationFormsDay.vue?vue&type=template&id=0e1070db&"
import script from "./RegistrationFormsDay.vue?vue&type=script&lang=ts&"
export * from "./RegistrationFormsDay.vue?vue&type=script&lang=ts&"
import style0 from "./RegistrationFormsDay.vue?vue&type=style&index=0&id=0e1070db&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports